var internalLink = function (params) {
	return {
		init: function () {
			this.wrapper = params.wrapper
			this.name = params.name
			this.disabled = params.disabled
			this.valueToPrefill = params.valueToPrefill
			this.currentLang = params.currentLang

			this.internalLinks = null

			// create container for these fields
			var container = document.createElement('div')
			container.classList.add('link-wrapper')

			// split the prefilled value
			var valueTxt = null
			this.valueLink = null
			var valuepageUUID = null
			if (this.valueToPrefill) {
				valueTxt = this.valueToPrefill[0]
				valuepageUUID = this.valueToPrefill[1]
				this.valueLink = this.valueToPrefill[2]
			}

			var labelWrapper = document.createElement('div')

			// create text input in case we want to render an HTML link
			var input = document.createElement('input')
			input.setAttribute('type', 'text')
			input.setAttribute('name', this.name)
			input.setAttribute('placeholder', 'Link label')
			if (this.required) input.setAttribute('required', this.required)
			if (valueTxt) input.value = valueTxt
			if (this.disabled) input.setAttribute('disabled', 'true')

			labelWrapper.appendChild(input)

			var linkWrapper = document.createElement('div')

			// create hidden field for page UUID
			this.hiddenPageUUIDField = document.createElement('input')
			this.hiddenPageUUIDField.setAttribute('type', 'hidden')
			this.hiddenPageUUIDField.setAttribute('name', this.name)
			if (valuepageUUID) this.hiddenPageUUIDField.value = valuepageUUID
			if (this.disabled) this.hiddenPageUUIDField.setAttribute('disabled', 'true')

			linkWrapper.appendChild(this.hiddenPageUUIDField)

			// create select to choose the internal link from
			this.selector = document.createElement('div')
			this.selector.classList.add('selector')
			this.select = document.createElement('select')
			if (this.disabled) this.select.setAttribute('disabled', 'true')
			this.select.setAttribute('name', this.name)
			if (this.required) this.select.setAttribute('required', this.required)

			this.select.addEventListener('change', this.selectChangedHandler.bind(this))

			this.selector.appendChild(this.select)
			linkWrapper.appendChild(this.selector)

			// create hidden field for page UUID
			this.targetField = document.createElement('input')
			this.targetField.setAttribute('type', 'hidden')
			this.targetField.setAttribute('name', this.name)
			this.targetField.value = '_self'
			if (this.disabled) this.targetField.setAttribute('disabled', 'true')
			linkWrapper.appendChild(this.targetField)

			container.appendChild(labelWrapper)
			container.appendChild(linkWrapper)

			this.wrapper.appendChild(container)
			// this.callback(this.conditionalLinkData)
		},

		selectChangedHandler: function (e) {
			// find the page UUID for this instance UUID
			for (var i = this.links.length - 1; i >= 0; i--) {
				if (this.links[i].instance === this.select.value) {
					this.hiddenPageUUIDField.value = this.links[i].page
					return
				}
			}
		},

		setLinksData: function (links) {
			if (!links) return
			this.links = links.data
			this.refreshOptionsForSelect(links)
		},

		refreshOptionsForSelect: function (links) {
			// sort the links based on the entity
			if (links.data) links.data.sort((a, b) => a.entity.toLowerCase() > b.entity.toLowerCase() ? 1 : -1)

			// add empty option
			var options = [
				{
					'label': 'Select a link ...',
					'instance': ''
				}]
			options = options.concat(links.data)

			var optGroup = null
			this.select.innerHTML = ''

			for (var i = 0; i < options.length; i++) {
				if (options[i]) {
					var option = document.createElement('option')
					var label = null

					if (options[i].translations) {
						if (options[i].translations[this.currentLang.id]) {
							label = options[i].translations[this.currentLang.id]
						} else {
							// find a filled in translation to show
							for (let translation in options[i].translations) {
								if (options[i].translations[translation]) {
									label = '(Not translated) ' + options[i].translations[translation]
									break
								}
							}
						}
					}

					var optGroupName = options[i].entity || ''
					if (optGroup !== optGroupName && optGroupName != '') {
						var optGroupElement = document.createElement('optgroup')
						optGroupElement.setAttribute('label', optGroupName)
						optGroup = optGroupName
						this.select.appendChild(optGroupElement)
					}

					option.innerHTML = label || options[i].label
					option.setAttribute('value', options[i].instance)
					if (optGroupName) {
						optGroupElement.appendChild(option)
					} else {
						this.select.appendChild(option)
					}
				}

				if (i === 0) this.setSelectValue()
			}
		},

		setSelectValue: function () {
			if (this.valueLink && this.links) {
				setTimeout(function () {
					this.select.value = this.valueLink
					// set label in uniform span
					var uniformSpan = this.select.parentNode.querySelector('span')

					for (var i = this.links.length - 1; i >= 0; i--) {
						if (this.links[i].instance === this.select.value) {
							var label = null

							if (this.links[i].translations) {
								if (this.links[i].translations[this.currentLang.id]) {
									label = this.links[i].translations[this.currentLang.id]
								} else {
									label = this.links[i].url
								}
							}

							if (uniformSpan) uniformSpan.textContent = label
							return
						}
					}
				}.bind(this), 100)
			}
		}
	}
}

export default internalLink
